export default __webpack_public_path__ + "static/media/vyoo-logo-rounded.27554ad6.svg";